import React, { useState, useEffect } from 'react';

const THINKING_MESSAGES = [
  "Processing your question...",
  "Gathering relevant information...",
  "Searching through scripture...",
  "Analyzing content...",
  "Compiling a detailed response...",
  "Cross-referencing passages...",
  "Still working on this — complex topics take a bit longer...",
];

export default function ThinkingIndicator() {
  const [msgIndex, setMsgIndex] = useState(0);
  const maxIndex = THINKING_MESSAGES.length - 1;
  useEffect(() => {
    if (msgIndex >= maxIndex) return;
    const timer = setTimeout(() => {
      setMsgIndex(prev => Math.min(prev + 1, maxIndex));
    }, 3500);
    return () => clearTimeout(timer);
  }, [msgIndex, maxIndex]);
  return (
    <div className="flex items-center gap-3 py-1" data-testid="thinking-indicator">
      <div className="flex gap-1">
        <span className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ background: 'var(--theme-accent)', animationDelay: '0ms' }} />
        <span className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ background: 'var(--theme-accent)', animationDelay: '150ms' }} />
        <span className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ background: 'var(--theme-accent)', animationDelay: '300ms' }} />
      </div>
      <span className="text-sm theme-text-secondary animate-in fade-in duration-300" key={msgIndex}>
        {THINKING_MESSAGES[msgIndex]}
      </span>
    </div>
  );
}
